/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { AdminDataWorkGrantAgencyDTO } from './AdminDataWorkGrantAgencyDTO';
import {
    AdminDataWorkGrantAgencyDTOFromJSON,
    AdminDataWorkGrantAgencyDTOFromJSONTyped,
    AdminDataWorkGrantAgencyDTOToJSON,
    AdminDataWorkGrantAgencyDTOToJSONTyped,
} from './AdminDataWorkGrantAgencyDTO';

/**
 * 
 * @export
 * @interface AdminDataWorkGrantDTO
 */
export interface AdminDataWorkGrantDTO  {
    /**
     * 
     * @type {number}
     * @memberof AdminDataWorkGrantDTO
     */
    id?: number;
    /**
     * 
     * @type {Array<AdminDataWorkGrantAgencyDTO>}
     * @memberof AdminDataWorkGrantDTO
     */
    grantAgencies?: Array<AdminDataWorkGrantAgencyDTO>;
    /**
     * 
     * @type {string}
     * @memberof AdminDataWorkGrantDTO
     */
    fundingText?: string;
}

/**
 * Check if a given object implements the AdminDataWorkGrantDTO interface.
 */
export function instanceOfAdminDataWorkGrantDTO(value: object): value is AdminDataWorkGrantDTO {
    return true;
}

export function AdminDataWorkGrantDTOFromJSON(json: any): AdminDataWorkGrantDTO {
    return AdminDataWorkGrantDTOFromJSONTyped(json, false);
}

export function AdminDataWorkGrantDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminDataWorkGrantDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
              'grantAgencies': json['grantAgencies'] == null ? undefined : ((json['grantAgencies'] as Array<any>).map(AdminDataWorkGrantAgencyDTOFromJSON)),
                  'fundingText': json['fundingText'] == null ? undefined : json['fundingText'],
    };
}

export function AdminDataWorkGrantDTOToJSON(json: any): AdminDataWorkGrantDTO {
    return AdminDataWorkGrantDTOToJSONTyped(json, false);
}

export function AdminDataWorkGrantDTOToJSONTyped(value?: AdminDataWorkGrantDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'grantAgencies': value['grantAgencies'] == null? value['grantAgencies']: (value['grantAgencies'] as Array<any>).map(AdminDataWorkGrantAgencyDTOToJSON),
        'fundingText': value['fundingText'],
    };
}


